module.exports = __webpack_public_path__ + "img/1.81e4fd13.png";